import { Form, Input, InputNumber, Typography } from "antd";
import { number } from "framer-motion";
export const MyInput = ({
  withoutForm,
  name,
  label,
  tooltip,
  type,
  size,
  disabled,
  required,
  message,
  value,
  placeholder,
  textArea,
  number,
  validator,
  className,
  ...props
}) => {
  // const {language}= useSelector(state => state?.app)
  const language = 0;
  return (
    <>
      {withoutForm ? (
        textArea ? (
          <Input.TextArea
            placeholder={placeholder || ""}
            value={value || ""}
            {...props}
          />
        ) : type === "password" ? (
          <Input.Password
            placeholder={placeholder || ""}
            value={value || ""}
            size={size || "middle"}
            disabled={disabled || false}
            {...props}
          />
        ) : (
          <Input
            type={type || "text"}
            placeholder={placeholder || ""}
            value={value || ""}
            size={size || "middle"}
            disabled={disabled || false}
            {...props}
          />
        )
      ) : (
        <Form.Item
          name={name}
          label={
            <Typography.Text strong className="fs-13x">
              {label}
            </Typography.Text>
          }
          tooltip={tooltip || null}
          labelAlign={language === "ar" ? "right" : "left"}
          rules={
            validator
              ? [
                  {
                    required: required,
                    message: message,
                  },
                  validator,
                ]
              : [
                  {
                    required: required,
                    message: message,
                  },
                ]
          }
          className={`w-100 custominput ${className}`}
        >
          {textArea ? (
            <Input.TextArea
              placeholder={placeholder || ""}
              value={value}
              {...props}
            />
          ) : type === "password" ? (
            <Input.Password
              placeholder={placeholder || ""}
              value={value}
              size={size || "middle"}
              disabled={disabled || false}
              {...props}
            />
          ) : number ? (
            <InputNumber
              placeholder={placeholder || ""}
              value={value}
              size={size || "middle"}
              disabled={disabled || false}
              {...props}
            />
          ) : (
            <Input
              type={type || "text"}
              placeholder={placeholder || ""}
              value={value}
              size={size || "middle"}
              disabled={disabled || false}
              {...props}
            />
          )}
        </Form.Item>
      )}
    </>
  );
};
